import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MerchantRegistrationComponent } from './merchant-registration/merchant-registration.component';
import { CustomerRegistrationComponent } from './customer-registration/customer-registration.component';
import { RegistrationComponent } from './registration/registration.component';

const routes: Routes = [
  {
    path: 'register',
    component: RegistrationComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'customer' },
      { path: 'merchant', component: MerchantRegistrationComponent },
      { path: 'customer', component: CustomerRegistrationComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RegistrationRoutingModule {}
